module.exports = __webpack_public_path__ + "img/preview-maquette.63a31903.png";